import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../../variant/variant';

@Component({
  selector: 'rt-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled',
    '[class.no-right-padding]': 'noRightPadding',
    '[class.uppercase]': 'uppercasedText',
    '[class.has-font-size-default]': 'hasFontSizeDefault',
    '[class]': 'variant',
  },
})
export class TabComponent {
  public static readonly VARIANTS: Variants = ['default', ['default', 'dark', 'no-padding']];
  @ComponentVariant(TabComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public isUnread: boolean = false;
  @Input() public count: number = 0;
  @Input() public href: string;
  @Input() public hrefTarget: string;
  @Input() public disabled: boolean = false;
  @Input() public noRightPadding: boolean = false;
  @Input() public uppercasedText: boolean = true;
  @Input() public hasFontSizeDefault: boolean = false;
}
